function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "37.9 19.1 291.5 16.3 277.7 3.2 50.3 5.7",
  fill: "#289C46"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "131.5 18 197.9 17.3 192.4 4.1 136.6 4.7",
  fill: "#EDEBA0"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "188.3 17.4 192.6 17.4 187.1 4.2 182.8 4.2",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "136.8 18 141.1 17.9 146.2 4.6 141.9 4.7",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -.376 1.8205)",
  x: 38.1,
  y: 17.6,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -.376 1.8195)",
  x: 131.6,
  y: 17.6,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -.371 2.1015)",
  x: 188.5,
  y: 17.3,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011033 .011033 .9999 -.3808 1.5369)",
  x: 136.9,
  y: 17.8,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -.5322 1.8226)",
  x: 38.3,
  y: 45.9,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011024 .011024 .9999 -.7619 1.7969)",
  x: 35.8,
  y: 52.6,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -.7619 1.797)",
  x: 129.4,
  y: 52.6,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -.7553 2.0779)",
  x: 186.2,
  y: 52.2,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -.7654 1.5112)",
  x: 134.7,
  y: 52.8,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011024 .011024 .9999 -.918 1.8001)",
  x: 36,
  y: 80.9,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m66.5 45.3c-15.1 0.2-27.3 4-27.2 8.6l0.4 33.1c0 1.5 1.4 2.9 3.7 4.1 4.7 2.4 13.6 4 23.7 3.9s18.9-1.9 23.6-4.4c2.3-1.2 3.6-2.7 3.6-4.2l-0.4-33.1c0-4.6-12.3-8.1-27.4-8z",
  fill: "#FADD75"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m66.7 63.5c-10.1 0.1-19.3-1.4-24.5-4-3.7-1.9-4.5-4-4.6-5.5-0.1-6.5 14.4-10 28.8-10.2s28.9 3.1 29 9.5c0 1.4-0.7 3.6-4.4 5.6-5 2.7-14.1 4.5-24.3 4.6zm-0.1-16.6c-15.7 0.2-25.7 4.3-25.7 7 0 0.8 1.1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-0.9 2.8-2 2.8-2.8 0-2.7-10.1-6.6-25.8-6.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m67 88.3c-14.4 0.2-28.9-3.1-29-9.5l-0.1-8.3h3.1c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8h3.1l0.1 8.3c0.2 6.4-14.3 10-28.7 10.1zm-25.9-13.1v3.6c0 2.7 10.1 6.6 25.9 6.4 15.7-0.2 25.7-4.3 25.7-7v-3.6c-0.4 0.3-0.9 0.6-1.4 0.8-5.1 2.8-14.2 4.5-24.4 4.6-10.1 0.1-19.3-1.4-24.5-4-0.4-0.3-0.9-0.5-1.3-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m67.1 96.6c-14.4 0.2-28.9-3.1-29-9.5l-0.1-8.3h3.1c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8h3.1l0.1 8.3c0.2 6.4-14.3 9.9-28.7 10.1zm-25.9-13.1v3.6c0 2.7 10.1 6.6 25.9 6.4 15.7-0.2 25.7-4.3 25.7-7v-3.6c-0.4 0.3-0.9 0.6-1.4 0.8-5.1 2.8-14.2 4.5-24.4 4.6-10.1 0.1-19.3-1.4-24.5-4-0.4-0.3-0.9-0.6-1.3-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m66.9 80c-10.1 0.1-19.3-1.4-24.5-4-3-1.5-4.5-3.4-4.6-5.5l-0.1-8.3h3.1c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8h3.1l0.1 8.3c0 2.1-1.5 4-4.4 5.6-5 2.7-14.1 4.4-24.2 4.5zm-25.9-13.1v3.6c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8v-3.6c-0.4 0.3-0.9 0.6-1.4 0.8-5.1 2.8-14.2 4.5-24.4 4.6-10.1 0.1-19.3-1.4-24.5-4-0.3-0.3-0.8-0.5-1.2-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m66.8 71.7c-10.1 0.1-19.3-1.4-24.5-4-3-1.5-4.5-3.4-4.6-5.5l-0.1-8.3h3.1c0 0.8 1.1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-0.9 2.8-2 2.8-2.8h3.1l0.1 8.3c0 2.1-1.5 4-4.4 5.6-4.9 2.7-14.1 4.4-24.2 4.5zm-25.9-13.1v3.6c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8v-3.6c-0.4 0.3-0.9 0.6-1.4 0.8-5.1 2.8-14.2 4.5-24.4 4.6-10.1 0.1-19.3-1.4-24.5-4-0.3-0.2-0.8-0.5-1.2-0.8z"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m68.6 52.4c-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.2 0.5 0.2 0.7 0.4 0.7 0.8v0.1l4.9-0.1v-0.2c0-0.8-0.6-1.4-1.9-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1l-4.8 0.1v1c-1.3 0.1-2.4 0.3-3.3 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.7 0.8 5.6 1.4c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.6-0.4 0.1-1.1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-5 0.1v0.2s0 0.1 0 0.1c0 0.8 0.6 1.5 1.9 1.8 0.9 0.3 2 0.4 3.5 0.5v1l4.8-0.1v-1c1.4-0.1 2.5-0.3 3.4-0.5 1.4-0.4 2-0.9 2-1.6 0.1-0.7-1.9-1.5-5.8-2.3z",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "d",
  d: "m42.3 59.4c5.2 2.6 14.3 4.2 24.5 4 10.1-0.1 19.2-1.8 24.4-4.6 3.7-2 4.4-4.1 4.4-5.6v0l0.4 33.1c0.1 6.5-14.4 10-28.8 10.2s-28.9-3.1-29-9.5l-0.4-33.1c0 1.6 0.8 3.6 4.5 5.5z"
}));

var _ref20 = /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d"
}));

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  points: "102.1 100.4 70.5 101.5 69.9 49.2 101.5 48.1",
  clipPath: "url(#c)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m27.7 62.8c-14.6 0.2-26.5 3.9-26.4 8.3l0.2 15.9c0 1.5 1.3 2.8 3.6 4 4.6 2.3 13.2 3.9 23 3.8s18.4-1.8 22.9-4.3c2.2-1.2 3.5-2.6 3.5-4.1l-0.2-15.9c0-4.3-12-7.8-26.6-7.7z",
  fill: "#FADD75"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m27.9 80.4c-9.8 0.1-18.7-1.4-23.7-3.9-3.6-1.8-4.4-3.9-4.4-5.3-0.1-6.3 14-9.7 27.9-9.9s28 3 28.1 9.2c0 1.4-0.7 3.5-4.3 5.4-5 2.8-13.8 4.4-23.6 4.5zm-0.2-16c-15.2 0.2-24.9 4.1-24.9 6.8 0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7 0-2.7-9.8-6.4-25.1-6.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28.1 96.5c-9.8 0.1-18.7-1.4-23.7-3.9-2.9-1.5-4.4-3.3-4.4-5.3l-0.1-8h3c0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7h3l0.1 8c0 2-1.4 3.9-4.3 5.4-5 2.6-13.8 4.3-23.6 4.4zm-25.1-12.7v3.5c0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7v-3.5c-0.4 0.3-0.8 0.5-1.3 0.8-5 2.7-13.8 4.3-23.6 4.4s-18.7-1.4-23.7-3.9c-0.6-0.2-1-0.5-1.4-0.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28 88.4c-9.8 0.1-18.7-1.4-23.7-3.9-2.9-1.5-4.4-3.3-4.4-5.3l-0.1-8h3c0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7h3l0.1 8c0 2-1.4 3.9-4.3 5.4-5 2.7-13.8 4.3-23.6 4.4zm-25.1-12.7v3.5c0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7v-3.5c-0.4 0.3-0.8 0.5-1.3 0.8-5 2.7-13.8 4.3-23.6 4.4s-18.7-1.4-23.7-3.9c-0.6-0.2-1-0.4-1.4-0.7z"
}));

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m29.7 70.3c-0.3-0.1-0.6-0.1-0.9-0.2-2.3-0.5-3.5-0.8-3.5-1.2 0-0.2 0.2-0.4 0.6-0.5s0.9-0.2 1.6-0.2c0.9 0 1.6 0.1 2 0.2 0.4 0.2 0.7 0.4 0.7 0.8v0.1l4.8-0.1v-0.2c0-0.8-0.6-1.4-1.8-1.7-0.8-0.2-1.8-0.4-3.1-0.5v-1l-4.7 0.1v1c-1.3 0.1-2.3 0.3-3.2 0.5-1.3 0.4-1.9 0.9-1.9 1.5 0 0.5 0.4 0.9 1.2 1.3 0.8 0.3 2.6 0.8 5.4 1.4 0.1 0 0.3 0.1 0.6 0.1 1.8 0.4 2.7 0.7 2.7 1 0 0.2-0.2 0.4-0.6 0.5s-1 0.2-1.8 0.2c-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-4.9 0.1v0.1 0.1c0 0.8 0.6 1.4 1.8 1.8 0.8 0.3 2 0.4 3.4 0.5v1l4.7-0.1v-1c1.3-0.1 2.4-0.3 3.3-0.5 1.3-0.4 2-0.9 2-1.6 0-0.6-1.9-1.4-5.7-2.1z",
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "m4.2 76.5c5 2.6 13.9 4 23.7 3.9s18.6-1.8 23.6-4.4c3.6-1.9 4.3-4 4.3-5.4v0l0.2 16c0.1 6.3-14 9.7-27.9 9.9s-28-3-28.1-9.2l-0.2-15.9c0 1.3 0.9 3.3 4.4 5.1z"
}));

var _ref26 = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b"
}));

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  points: "62 100 31.4 101.1 31 66.6 61.6 65.5",
  clipPath: "url(#a)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var SvgConsumo1 = function SvgConsumo1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 291.8 96.6",
    viewBox: "0 0 291.8 96.6",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConsumo1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/consumo1.a76f4af8.svg";
export { ForwardRef as ReactComponent };